<template>
  <div class="permission-info">
    <div class="tips">
      <el-tag class="title">
        点击对应业务，可以查看对应业务里面的权限
      </el-tag>
    </div>
    <div class="user-role-container h-full">
      <div class="role-list">
        <div class="list">
          <div
            v-for="(v, idx) in businessData"
            :key="v.businessId"
            :class="['item', leftAcitveIndex === idx ? 'active' : '']"
            @click="changeBusiness(v.businessId, idx)"
          >
            {{ v.businessName }}
          </div>
        </div>
      </div>
      <div
        v-loading="loading"
        class="role-tree"
      >
        <div class="tree-header">
          <div class="title">
            {{ businessData[leftAcitveIndex]?.businessName }}权限详细
          </div>
        </div>
        <menu-permission ref="treeRef" :data="treeData" :checked-data="treeCheckedData" />
      </div>
    </div>
  </div>
</template>
<script setup lang='ts'>
import MenuPermission from '../menu-permission-form/MenuPermission.vue';
import { IRoleMenuItem, IBusinessAuthInfo } from '../../../../types';
import { PropType, ref, watch } from 'vue';

defineOptions({ name: 'AgentRole' });
const props = defineProps({
  data: {
    type: Array as PropType<IBusinessAuthInfo[]>,
    default: () => [],
  },
});

const leftAcitveIndex = ref(0);

const businessData = ref<IBusinessAuthInfo[]>();
const treeRef = ref<InstanceType<typeof MenuPermission>>();
const treeData = ref([] as IRoleMenuItem[]);
const treeCheckedData = ref([] as number[]);
const loading = ref(false);

function changeBusiness(businessId: number, idx: number) {
  leftAcitveIndex.value = idx;
  
  const index = businessData.value.findIndex((v) => v.businessId === businessId);

  treeData.value = businessData.value[index].menuData;
  treeCheckedData.value = businessData.value[index].menuIds;
}

watch(
  () => props.data,
  () => {
    if (props.data) {
      businessData.value = props.data && props.data.length > 0 ? props.data : [];
      treeData.value = props.data && businessData.value[leftAcitveIndex.value]?.menuData;
      treeCheckedData.value = props.data && businessData.value[leftAcitveIndex.value]?.menuIds;
    }
  },
  {
    immediate: true,
    deep: true, 
  },
);
</script>

<style lang="scss" scoped src="./styles/index.scss"></style>
